<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="matricula-lotacao-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-3" v-if="opcoes">
                                <label for="opcaoLotacaoMatricula" class="form-label">Opcao</label>
                                <Multiselect id="opcaoLotacaoMatricula" v-model="opcao_id" :options="opcoes_select"
                                    :searchable="true" @change="refreshTable" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="pelotaoLotacaoMatricula" class="form-label">Pelotao</label>
                                <input id="pelotaoLotacaoMatricula" v-model="pelotao" @keyup="apertouEnter" type="text"
                                    class="form-control form-control-solid" placeholder="Pelotao" />
                            </div>

                            <div class="col-12 col-lg-6 panel-actions">
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                            <th>Id</th>
                            <th>Unidade</th>
                            <th>Opcao</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import CardRh from "@/components/cards/ManzaCard.vue";
import AlocacaoService from "@/service/v1/sigap/AlocacaoService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { User } from "@/store/modules/AuthModule";
import { Prop } from "vue-property-decorator";

const authStore = namespace("auth");

@Options({
    name: "OpcaoIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class OpcaoIndex extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public currentUser!: User;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public modelo: any = null;
    public dados: any = null;
    public opcao_id: any = null;
    public matriculaId: any = null;
    public opcoes: any = null;
    public pelotao = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.opcao_id = null;
        this.pelotao = "";
        this.refreshTable();
    }

    get opcoes_select() {
        if (this.opcoes) {
            return this.opcoes.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getOpcao() {
        this.processando = true;
        this.service.getOpcao()
            .then(response => {
                this.opcoes = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new AlocacaoService();
        this.getOpcao();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    opcao: this.opcao_id,
                    pelotao: this.pelotao,
                    matriculaId: this.matriculaId,
                    search: d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[2, 'asc']];
        this.config.columns = [
            { data: "id", name: "id" },
            { data: "unidade.descricao", name: "unidade" },
            { data: "opcao", name: "opcao", class: "desktop" },
        ];

        this.config.columnDefs = [
            {
                targets: 2,
                render: (row) => {
                    return row.nome.replaceAll("_", " ");
                }
            },
        ];
    }
}
</script>

<style scoped>
.matricula-lotacao-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
